import React, { useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import FormRenderer, { ComponentMapper, FormTemplate } from "../../common/FormRenderer";
import PageLoader from "../../shared/PageLoader";
import { Alert } from "react-bootstrap";
import { API_RESULT, ERROR_MESSAGES } from "../../../utils/constants";
import { useForgotPassword } from "../../../backend/auth";
import { LOGIN_FIELDS } from "./Authenticate.constants";
import { AxiosError } from "axios";

function ForgotPasswordModal({ onClose }: any) {
    const [recoverySent, setRecoverySent] = useState(false);
    const [apiError, setError] = useState<any>(null);
    const [submitting, setSubmitting] = useState(false);
    const [form, setForm] = useState<any>({});
    const [message, setMessage] = useState<string>("");
    const { forgotPassword } = useForgotPassword((response: any) => {
        setSubmitting(false);
        if(response instanceof AxiosError){
            const { data } = (response || {}).response || {};
            const error = (data || {}).error || (data || {}).message || ERROR_MESSAGES.ERROR;
            setError(error);
        } else {
            setMessage(response.data.message)
            setRecoverySent(true);
        }
    }, () => {
        setSubmitting(false);
        setError(ERROR_MESSAGES.DEFAULT);
    });

    const schema = {
        fields: [{ ...LOGIN_FIELDS.USERNAME }],
    };

    function recoverPassword({ username }: any) {
        setError(null);
        if (form.valid) {
            setSubmitting(true);
            forgotPassword({ username });
        }
    }

    return (
        <>
            <Modal show={true} backdrop="static" animation={true} dialogClassName="alert-modal" size="lg" centered={true}>
                <Modal.Header closeButton={true} onHide={onClose}>
                    <Modal.Title className="bg">Recover Password</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex flex-column align-items-center">
                        {
                            recoverySent ?
                                <>
                                    <FontAwesomeIcon icon={faCircleCheck} style={{ fontSize: '106px' }} className="mb-4 text-success" />
                                    <div className="text-xxl text-success">Email Sent</div>
                                    <div className="text-md mb-4">{message}</div>
                                </> :
                                <>
                                    <div className="text-md mb-4">Enter your username and we'll send you a link to reset your password</div>
                                    {
                                        apiError && <Alert variant="danger">{apiError}</Alert>
                                    }
                                    <div className="col-md-9 m-auto">
                                        <FormRenderer FormTemplate={FormTemplate}
                                            initialValues={{ submitBtnText: 'Send link to email', fullWidth: false }}
                                            componentMapper={ComponentMapper}
                                            schema={schema}
                                            debug={setForm}
                                            onSubmit={recoverPassword}
                                        />
                                    </div>
                                </>
                        }
                    </div>
                </Modal.Body>
            </Modal>
            {submitting && <PageLoader />}
        </>
    )
}

export default ForgotPasswordModal;
